import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field from '../../Field';
let Config = require('Config');

class Pension extends Component {
    constructor(props) {
        super(props);
        this.inputComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    getChildInputComponents() {
        return this.inputComponents;
    }

    render() {
        let index = this.props.financialRefereeStatus - 1;
        return(
            <div className="question-section">
                <question-row class="header-row">
                    <div className="question-main">
                        <h2>In receipt of a pension</h2>
                    </div>
                </question-row>

                {/* Xpress - only ask for annual income */}
                {this.props.productId === 11 ?
                    <Field
                        fieldName={'annual_salary' + index}
                        question="Your annual income"
                        storageKey="applicantAnnualIncome"
                        type="money"
                        hasBorder={false}
                        hasPadding={false}
                        dataValidation="2_decimal_money"
                        source={this.props.source}
                        loadValues={true}
                        loadingKey={this.props.source + '.applicantAnnualIncome'}
                        ref={(instance) => {
                            this.inputComponents.push(instance);
                        }}
                    />
                :
                    <div>
                        <Field
                            fieldName={'start_date' + index}
                            storageKey="employmentStartDate"
                            question="When did you start receiving this source of income?"
                            type="date"
                            subType="full"
                            dataValidation={'required_field'}
                            source={this.props.source}
                            loadValues={true}
                            loadingKey={this.props.source + '.employmentStartDate'}
                            ref={(instance) => {
                                this.inputComponents.push(instance);
                            }}
                        />

                        <Field
                            fieldName={'annual_salary' + index}
                            question="Your annual income"
                            storageKey="applicantAnnualIncome"
                            type="money"
                            hasBorder={false}
                            hasPadding={false}
                            dataValidation="2_decimal_money"
                            source={this.props.source}
                            loadValues={true}
                            loadingKey={this.props.source + '.applicantAnnualIncome'}
                            ref={(instance) => {
                                this.inputComponents.push(instance);
                            }}
                        />

                        {!window.uorn(window.localStorage.getItem('BankValidationStrategy')) ?
                            <div>
                                <Field
                                    fieldName={'payment_frequency' + index}
                                    type="select"
                                    question="Frequency of pay"
                                    storageKey="frequencyOfPay"
                                    source={this.props.source}
                                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.frequencyOfPay'}
                                    loadValues={true}
                                    isInt={true}
                                    options={[
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.WEEKLY,
                                            option_text: "Weekly"
                                        },
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.MONTHLY,
                                            option_text: "Monthly"
                                        },
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.TWO_WEEKLY,
                                            option_text: "2 weekly"
                                        },
                                        {
                                            option_value: Config.financialRefereePaymentFrequencies.FOUR_WEEKLY,
                                            option_text: "4 Weekly"
                                        }
                                    ]}
                                />

                                <Field
                                    type="text"
                                    fieldName={'tax_code' + index}
                                    storageKey={'taxCode'}
                                    question="My tax code"
                                    dataValidation="tax_code.non_mandatory"
                                    maxLength={8}
                                    source={this.props.source}
                                    loadingKey={'BaseIndividualApplication.financialReferees.' + index + '.taxCode'}
                                    loadValues={true}
                                    ref={(instance) => {this.inputComponents.push(instance);}}
                                />
                            </div>
                        : null}

                        <Field
                            fieldName={'statement' + index}
                            type="upload"
                            question="Upload evidence"
                            helpText="For this reference suitable documents are:<br />A copy of the pension statement<br />Copies of the last 3 months bank statements<br />A P60"
                            showHelpIcon={true}
                            allowFileUploads={true}
                            allowCameraUploads={true}
                            contextInfo={'Employment evidence'}
                            labelExtra={'You can upload your evidence now below, or later upon completion of this form.'}
                            source={this.props.source}
                        />
                    </div>
                }
            </div>
        );
    }
}

Pension.propTypes = {
    productId:                  PropTypes.number.isRequired,
    termLength:                 PropTypes.number,
    source:                     PropTypes.string.isRequired,
    financialRefereeStatus:     PropTypes.oneOf([1, 2, 3]),
};

export default Pension;


// WEBPACK FOOTER //
// ./src/components/Screens/Sections/Pension.js